@if (exibir) {
  <div class="simple-modal" role="dialog" aria-modal="true" aria-labelledby="file-preview-modal-titulo">
    <div class="simple-modal-dialog modal-lg">
      <div class="simple-modal-content">
        <div class="simple-modal-header">
          <div>
            <h5 class="simple-modal-title" id="file-preview-modal-titulo">
              {{ filePreview?.title }}
              @if (filePreview?.subtitle) {
                <span> - {{ filePreview?.subtitle }}</span>
              }
            </h5>
            @if (filePreview?.previousFileName) {
              <p class="mb-0 mt-2">
                {{ 'modal.arquivo_anterior' | translate }}:
                <span class="text-muted">{{ filePreview?.previousFileName }}</span>
              </p>
            }
            <p class="mb-0 mt-2">
              {{
                filePreview?.previousFileName
                  ? ('modal.novo_arquivo' | translate)
                  : ('modal.arquivo_selecionado' | translate)
              }}:
              <span class="text-success fw-bold">{{ filePreview?.file?.name }}</span>
            </p>
          </div>
          <button type="button" class="btn-close" aria-label="Fechar" (click)="cancelar()"></button>
        </div>
        <div class="simple-modal-body">
          @if (isPreviewable) {
            <iframe [src]="trustedUrl" width="100%" title="Pré-visualização do arquivo"></iframe>
          }
        </div>
        <div class="simple-modal-footer">
          <div class="d-flex">
            <div class="me-auto">
              <button type="button" class="btn btn-secondary" (click)="cancelar()">
                {{ 'modal.cancelar' | translate }}
              </button>
            </div>
            <div class="ms-auto">
              <button type="button" class="btn btn-primary" (click)="enviar()">
                {{ 'shared.enviar' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div (click)="cancelar()" class="overlay" aria-hidden="true"></div>
}
